import { shallowEqual, useSelector } from 'react-redux'

import type { AppState } from '@app/state'
import type { State } from '@app/state/feature-flags';
import { queries } from '@app/state/feature-flags'

export interface IUseFeatureFlags {
  isFeatureFlagEnabled: (feature: string) => boolean
}

export function useFeatureFlags(): IUseFeatureFlags {
  const featureFlagState = useSelector<AppState, State>(
    (state) => state.featureFlags,
    shallowEqual,
  )

  return {
    isFeatureFlagEnabled(feature: string) {
      return queries.isFeatureFlagEnabled(featureFlagState, feature)
    },
  }
}
